import { render, staticRenderFns } from "./GroupTabPanel.vue?vue&type=template&id=401a8fe2&scoped=true&"
import script from "./GroupTabPanel.vue?vue&type=script&lang=js&"
export * from "./GroupTabPanel.vue?vue&type=script&lang=js&"
import style0 from "./GroupTabPanel.vue?vue&type=style&index=0&id=401a8fe2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "401a8fe2",
  null
  
)

export default component.exports